import Mailcheck from 'mailcheck'
import validator from 'validator'
import { helpers } from 'vuelidate/lib/validators'

const isBeforeDate = (d1, d2) => {
  const date1 = d1 instanceof Date ? d1 : new Date(d1)
  const date2 = d2 instanceof Date ? d2 : new Date(d2)

  if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
    return false
  }

  const t1 = date1.getTime()
  const t2 = date2.getTime()

  return t2 > t1
}

const isAfterDate = (d1, d2) => {
  const date1 = d1 instanceof Date ? d1 : new Date(d1)
  const date2 = d2 instanceof Date ? d2 : new Date(d2)

  if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
    return false
  }

  const t1 = date1.getTime()
  const t2 = date2.getTime()

  return t2 < t1
}

export const httpUrl = value =>
  !helpers.req(value) || validator.isURL(value, { protocols: ['http', 'https'] })

export const date = value => {
  if (!helpers.req(value)) {
    return true
  }

  const dateValue = new Date(value)
  if (isNaN(dateValue.getTime())) {
    return false
  }

  return validator.isISO8601(dateValue.toISOString())
}

export const minDate = getDate => value => {
  const d = new Date(getDate())
  const valueDate = new Date(value)

  return !helpers.req(value) || !helpers.req(d) || !isBeforeDate(valueDate, d)
}

export const maxDate = getDate => value => {
  const d = new Date(getDate())
  const valueDate = new Date(value)

  return !helpers.req(value) || !helpers.req(d) || !isAfterDate(valueDate, d)
}

export const notIn = (values, ignore) => value => {
  if (ignore) return !helpers.req(value) || !values.filter(v => v !== ignore).includes(value)

  return !helpers.req(value) || !values.includes(value)
}

export const minValueIf = (minValue, getCondition) => value =>
  getCondition() ? true : value >= minValue

export const checkEmailMisspelled = email => {
  let checkedMail = null

  Mailcheck.run({
    email: email,
    topLevelDomains: [...Mailcheck.defaultTopLevelDomains, 'hr'],
    suggested: function (suggestion) {
      checkedMail = suggestion.full
    },
  })

  return checkedMail
}

export const uniqueTicketCategoryPriority = (categories, id) => value => {
  let filterCategories = [...categories]

  if (id) {
    filterCategories = filterCategories.filter(c => c.id !== id)
  }

  return !filterCategories.some(cp => cp.priority === value)
}
